import { render, staticRenderFns } from "./PessoaCaptacao.vue?vue&type=template&id=7395ddf1&scoped=true&"
import script from "./PessoaCaptacao.vue?vue&type=script&lang=js&"
export * from "./PessoaCaptacao.vue?vue&type=script&lang=js&"
import style0 from "./PessoaCaptacao.vue?vue&type=style&index=0&id=7395ddf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395ddf1",
  null
  
)

export default component.exports